import React from 'react';
import { View } from 'react-native';

interface Point {
  x: number;
  y: number;
}

interface WebLinearGradientProps {
  colors: string[];
  locations?: number[];
  start?: Point;
  end?: Point;
  style?: any;
  children?: React.ReactNode;
}

// CSS gradient angles are measured clockwise from "up" (0deg), while RN's
// start/end points use a y-down unit square — this converts one to the other.
const getAngle = (start: Point, end: Point): number => {
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  return Math.atan2(dy, dx) * (180 / Math.PI) + 90;
};

const LinearGradient: React.FC<WebLinearGradientProps> = ({
  colors,
  locations,
  start = { x: 0, y: 0 },
  end = { x: 0, y: 1 },
  style,
  children,
}) => {
  const angle = getAngle(start, end);
  const stops = colors
    .map((color, i) => (locations?.[i] !== undefined ? `${color} ${locations[i] * 100}%` : color))
    .join(', ');

  return (
    <View style={[style, { backgroundImage: `linear-gradient(${angle}deg, ${stops})` } as any]}>
      {children}
    </View>
  );
};

export default LinearGradient;
